/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AwardMedalIcon20Light = forwardRef('AwardMedalIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.784 2.09a.5.5 0 0 0-.696.123L10 5.2 7.912 2.213a.5.5 0 0 0-.82.574l2.313 3.306A5.968 5.968 0 0 0 6.43 7.242L2.912 2.213a.5.5 0 0 0-.82.574l3.582 5.12a6 6 0 1 0 8.651 0l3.582-5.12a.5.5 0 1 0-.82-.574L13.57 7.242a5.968 5.968 0 0 0-2.975-1.149l2.312-3.306a.5.5 0 0 0-.123-.697ZM5 12.064a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z" })));
});
